// Добавьте этот скрипт для работы кнопок развертывания
document.addEventListener('DOMContentLoaded', function() {
  const toggleButtons = document.querySelectorAll('.chess-block__toggle-btn');

  toggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      const textWrapper = this.closest('.chess-block__text-wrapper');
      const textElement = textWrapper.querySelector('.chess-block__text');
      const toggleText = textWrapper.querySelector('.chess-block__toggle-text');
      const svgIcon = this.querySelector('svg');

      textElement.classList.toggle('chess-block__text--collapsed');
      textElement.classList.toggle('chess-block__text--expanded');
      this.classList.toggle('chess-block__toggle-btn--expanded');

      if (textElement.classList.contains('chess-block__text--expanded')) {
        toggleText.textContent = 'Свернуть';
      } else {
        toggleText.textContent = 'Развернуть';
      }
    });
  });
});
